App.config(['$stateProvider', '$urlRouterProvider', '$locationProvider', 'Config', 'Configurator', function ($stateProvider, $urlRouterProvider, $locationProvider, Config, Configurator) {

    $urlRouterProvider.otherwise('/dashboard');

    $stateProvider
        .state('root', {
            url: '',
            abstract: true,
            templateUrl: Config.PAGES_DIR + 'root.html',
        })
        .state('root.login', {
            url: '/login',
            views: {
                'page': {
                    templateUrl: Config.PAGES_DIR + 'login.html',
                    controller: 'LoginCtrl',
                }
            },
            params: {
                person: null,
                persons: null,
                choose: null,
                prices: null,
                summary: null,
                invitationToken: null,
                redirectToThirdStep: null,
                redirectLocation: null
            }
        })
        .state('root.register', {
            url: '/register/:invitationToken',
            views: {
                'page': {
                    templateUrl: Config.PAGES_DIR + 'register.html',
                    controller: 'RegisterCtrl',
                }
            },
            params: {
                person: null,
                persons: null,
                choose: null,
                prices: null,
                summary: null,
                invitationToken: null,
                redirectToThirdStep: null,
                redirectLocation: null
            }
        })
        .state('root.remind', {
            url: '/remind',
            views: {
                'page': {
                    templateUrl: Config.PAGES_DIR + 'remind.html',
                    controller: 'RemindCtrl',
                }
            }
        })
        .state('root.remember', {
            url: '/remember/:token',
            views: {
                'page': {
                    templateUrl: Config.PAGES_DIR + 'remember.html',
                    controller: 'RememberCtrl',
                }
            }
        })
        .state('root.completeRegistration', {
            url: '/completeRegistration/:token',
            views: {
                'page': {
                    templateUrl: Config.PAGES_DIR + 'complete_registration.html',
                    controller: 'CompleteRegistrationCtrl',
                }
            }
        })
        .state('root.confirmRegistration', {
            url: '/confirmRegistration/:token',
            views: {
                'page': {
                    templateUrl: Config.PAGES_DIR + 'confirm_registration.html',
                    controller: 'ConfirmRegistrationCtrl',
                }
            }
        })
        .state('root.confirmRelativeRegistration', {
            url: '/confirmRelativeRegistration/:token',
            views: {
                'page': {
                    templateUrl: Config.PAGES_DIR + 'confirm_relative_registration.html',
                    controller: 'ConfirmRelativeRegistrationCtrl',
                }
            }
        })
        .state('root.dashboard', {
            url: '/dashboard',
            views: {
                'page': {
                    templateUrl: Config.PAGES_DIR + 'dashboard.html',
                    controller: 'DashboardCtrl',
                }
            },
        });

    if (Configurator.isInsuranceEnabled) {
        $stateProvider
            .state('root.health', {
                url: '/health',
                views: {
                    'page': {
                        templateUrl: Config.PAGES_DIR + 'health.html',
                        controller: 'HealthCtrl',
                    }
                }
            })
            .state('root.health.start', {
                url: '/start',
                views: {
                    'step': {
                        templateUrl: Config.PAGES_DIR + 'Health/start.html',
                        controller: 'HealthStartCtrl',
                    }
                }
            })
            .state('root.health.variant', {
                url: '/variant',
                views: {
                    'step': {
                        templateUrl: Config.PAGES_DIR + 'Health/variant.html',
                        controller: 'HealthVariantCtrl',
                    }
                }
            })
            .state('root.health.document', {
                url: '/document',
                views: {
                    'step': {
                        templateUrl: Config.PAGES_DIR + 'Health/document.html',
                        controller: 'HealthDocumentCtrl',
                    }
                }
            })
            .state('root.health.visit', {
                url: '/visit',
                views: {
                    'step': {
                        templateUrl: Config.PAGES_DIR + 'Health/visit.html',
                        controller: 'HealthVisitCtrl',
                    }
                }
            })
            .state('root.health.standard', {
                url: '/standard',
                views: {
                    'step': {
                        templateUrl: Config.PAGES_DIR + 'Health/standard.html',
                        controller: 'HealthStandardCtrl',
                    }
                }
            })
            .state('root.health.place', {
                url: '/place',
                views: {
                    'step': {
                        templateUrl: Config.PAGES_DIR + 'Health/place.html',
                        controller: 'HealthPlaceCtrl',
                    }
                }
            });
    } else if (Configurator.healthInsurancePzuwEnabled) {
        $stateProvider
            .state('root.health', {
                url: '/health',
                views: {
                    'page': {
                        templateUrl: Config.PAGES_DIR + 'healthPzuw.html',
                        controller: 'HealthPzuwCtrl',
                    }
                },
                params: {
                    branch: null,
                    package: null,
                    statement: null
                }
            })
            .state('root.health.start', {
                url: '/start',
                views: {
                    'step': {
                        templateUrl: Config.PAGES_DIR + 'HealthPzuw/start.html',
                        controller: 'HealthPzuwStartCtrl',
                    }
                }
            })
            .state('root.health.variant', {
                url: '/variant',
                views: {
                    'step': {
                        templateUrl: Config.PAGES_DIR + 'HealthPzuw/variant.html',
                        controller: 'HealthPzuwVariantCtrl',
                    }
                }
            })
            .state('root.health.visit', {
                url: '/visit',
                views: {
                    'step': {
                        templateUrl: Config.PAGES_DIR + 'HealthPzuw/visit.html',
                        controller: 'HealthPzuwVisitCtrl',
                    }
                }
            })
            .state('root.health.facility', {
                url: '/facility',
                views: {
                    'step': {
                        templateUrl: Config.PAGES_DIR + 'HealthPzuw/facility.html',
                        controller: 'HealthPzuwFacilityCtrl',
                    }
                }
            })
            .state('root.health.document', {
                url: '/document',
                views: {
                    'step': {
                        templateUrl: Config.PAGES_DIR + 'HealthPzuw/document.html',
                        controller: 'HealthPzuwDocumentCtrl',
                    }
                }
            })
            .state('root.health.refund', {
                url: '/refund',
                views: {
                    'step': {
                        templateUrl: Config.PAGES_DIR + 'HealthPzuw/refund.html',
                        controller: 'HealthPzuwRefundCtrl',
                    }
                }
            })
            .state('root.health.package', {
                url: '/package',
                views: {
                    'step': {
                        templateUrl: Config.PAGES_DIR + 'Home/HealthPzuw/package.html',
                        controller: 'HealthPzuwPackageCtrl',
                    }
                }
            })
            .state('root.health.form', {
                url: '/form',
                views: {
                    'step': {
                        templateUrl: Config.PAGES_DIR + 'Home/HealthPzuw/form.html',
                        controller: 'HealthPzuwFormCtrl',
                    }
                },
                params: {
                    // package: null,
                    proposedDate: null,
                    // lastDeclaration: null,
                }
            })
            .state('root.health.summary', {
                url: '/summary',
                views: {
                    'step': {
                        templateUrl: Config.PAGES_DIR + 'Home/HealthPzuw/summary.html',
                        controller: 'HealthPzuwSummaryCtrl',
                    }
                },
                params: {
                    declaration: null,
                    summaryPrice: 0,
                    previousDeclarationStatus: null
                }
            })
            .state('root.health.list', {
                url: '/list',
                views: {
                    'step': {
                        templateUrl: Config.PAGES_DIR + 'Home/HealthPzuw/list.html',
                        controller: 'HealthPzuwListCtrl',
                    }
                },
                params: {
                    declaration: null,
                    summaryPrice: 0
                }
            })
            .state('root.health.details', {
                url: '/details',
                views: {
                    'step': {
                        templateUrl: Config.PAGES_DIR + 'Home/HealthPzuw/details.html',
                        controller: 'HealthPzuwDetailsCtrl',
                    }
                },
                params: {
                    package: null
                }
            });
    }

    // @TODO <HEALTH2019>
    $stateProvider
        .state('root.healthInsuranceInfo', {
            url: '/healthInsuranceInfo',
            views: {
                'page': {
                    templateUrl: Config.PAGES_DIR + 'healthInsuranceInfo.html',
                    // controller: 'HealthInsuranceInfoCtrl',
                }
            }
        })
        .state('root.healthInsuranceInfo.start', {
            url: '/start',
            views: {
                'step': {
                    templateUrl: Config.PAGES_DIR + 'HealthInsuranceInfo/start.html',
                    controller: 'HealthInsuranceInfoStartCtrl',
                }
            }
        })
        .state('root.healthInsuranceInfo.variant', {
            url: '/variant',
            views: {
                'step': {
                    templateUrl: Config.PAGES_DIR + 'HealthInsuranceInfo/variant.html',
                    controller: 'HealthInsuranceInfoVariantCtrl',
                }
            }
        })
        .state('root.healthInsuranceInfo.document', {
            url: '/document',
            views: {
                'step': {
                    templateUrl: Config.PAGES_DIR + 'HealthInsuranceInfo/document.html',
                    controller: 'HealthInsuranceInfoDocumentCtrl',
                }
            }
        })
        .state('root.healthInsuranceInfo.visit', {
            url: '/visit',
            views: {
                'step': {
                    templateUrl: Config.PAGES_DIR + 'HealthInsuranceInfo/visit.html',
                    controller: 'HealthInsuranceInfoVisitCtrl',
                }
            }
        })
        .state('root.healthInsuranceInfo.standard', {
            url: '/standard',
            views: {
                'step': {
                    templateUrl: Config.PAGES_DIR + 'HealthInsuranceInfo/standard.html',
                    controller: 'HealthInsuranceInfoStandardCtrl',
                }
            }
        })
        .state('root.healthInsuranceInfo.place', {
            url: '/place',
            views: {
                'step': {
                    templateUrl: Config.PAGES_DIR + 'HealthInsuranceInfo/place.html',
                    controller: 'HealthInsuranceInfoPlaceCtrl',
                }
            }
        })
        .state('root.healthInsuranceInfo.refund', {
            url: '/refund',
            views: {
                'step': {
                    templateUrl: Config.PAGES_DIR + 'HealthInsuranceInfo/refund.html',
                    controller: 'HealthInsuranceInfoRefundCtrl',
                    controllerAs: 'refund'
                }
            }
        })
        // @TODO </HEALTH2019>

        .state('root.healthInsuranceWithPayments', {
            url: '/healthInsuranceWithPayments',
            views: {
                'page': {
                    templateUrl: Config.PAGES_DIR + 'healthInsuranceWithPayments.html',
                    // controller: 'HealthInsuranceInfoCtrl',
                }
            }
        })
        .state('root.healthInsuranceWithPayments.start', {
            url: '/start',
            views: {
                'step': {
                    templateUrl: Config.PAGES_DIR + 'HealthInsuranceWithPayments/start.html',
                    controller: 'HealthInsuranceWithPaymentsStartCtrl',
                }
            }
        })
        .state('root.healthInsuranceWithPayments.variant', {
            url: '/variant',
            views: {
                'step': {
                    templateUrl: Config.PAGES_DIR + 'HealthInsuranceWithPayments/variant.html',
                    controller: 'HealthInsuranceInfoVariantCtrl',
                }
            }
        })
        .state('root.healthInsuranceWithPayments.place', {
            url: '/place',
            views: {
                'step': {
                    templateUrl: Config.PAGES_DIR + 'HealthInsuranceWithPayments/place.html',
                    controller: 'HealthInsuranceWithPaymentsPlaceCtrl',
                }
            }
        })
        .state('root.healthInsuranceWithPayments.visit', {
            url: '/visit',
            views: {
                'step': {
                    templateUrl: Config.PAGES_DIR + 'HealthInsuranceWithPayments/visit.html',
                    controller: 'HealthInsuranceWithPaymentsVisitCtrl',
                }
            }
        })
        .state('root.healthInsuranceWithPayments.document', {
            url: '/document',
            views: {
                'step': {
                    templateUrl: Config.PAGES_DIR + 'HealthInsuranceWithPayments/document.html',
                    controller: 'HealthInsuranceWithPaymentsDocumentCtrl',
                }
            }
        })
        .state('root.healthInsuranceWithPayments.refund', {
            url: '/refund',
            views: {
                'step': {
                    templateUrl: Config.PAGES_DIR + 'HealthInsuranceWithPayments/refund.html',
                    controller: 'HealthInsuranceWithPaymentsRefundCtrl',
                }
            }
        });

    if (Configurator.isLifeInsuranceEnabled) {
        $stateProvider
            .state('root.life', {
                url: '/life',
                views: {
                    'page': {
                        templateUrl: Config.PAGES_DIR + 'life.html',
                        controller: 'LifeCtrl',
                    }
                },
                params: {
                    person: null,
                    persons: null,
                    choose: null,
                    prices: null,
                    partner: null,
                    assured: null,
                    summary: null,
                    isAssured: null,
                    isPartner: null,
                    saveResponse: null,
                    declarationEntity: null,
                    declarations: null
                }
            })
            .state('root.life.list', {
                url: '/package',
                views: {
                    'step': {
                        templateUrl: Config.PAGES_DIR + 'Life/list.html',
                        controller: 'LifeListCtrl'
                    }
                }
            })
            .state('root.life.edit', {
                url: '/edit',
                views: {
                    'step': {
                        templateUrl: Config.PAGES_DIR + 'Life/edit.html',
                        controller: 'LifeEditCtrl'
                    }
                }
            })
            .state('root.life.details', {
                url: '/details',
                views: {
                    'step': {
                        templateUrl: Config.PAGES_DIR + 'Life/details.html',
                        controller: 'LifeDetailsCtrl'
                    }
                },
                params: {
                    package: null
                }
            })
            .state('root.life.related', {
                url: '/related',
                views: {
                    'step': {
                        templateUrl: Config.PAGES_DIR + 'Life/related.html',
                        controller: 'LifeRelatedCtrl'
                    }
                },
                params: {
                    declarationEntity: null
                }
            })
            .state('root.life.start', {
                url: '/start',
                views: {
                    'step': {
                        templateUrl: Config.PAGES_DIR + 'Life/start.html',
                        controller: 'LifeStartCtrl',
                    }
                }
            })
            .state('root.life.variant', {
                url: '/variant',
                views: {
                    'step': {
                        templateUrl: Config.PAGES_DIR + 'Life/variant.html',
                        controller: 'LifeVariantCtrl',
                    }
                }
            })
            .state('root.life.salaried', {
                url: '/salaried',
                views: {
                    'step': {
                        templateUrl: Config.PAGES_DIR + 'Life/salaried.html',
                        controller: 'LifeSalariedCtrl',
                    }
                }
            })
            .state('root.life.data', {
                url: '/data',
                views: {
                    'step': {
                        templateUrl: Config.PAGES_DIR + 'Life/data.html',
                        controller: 'LifeDataCtrl',
                    }
                }
            })
            .state('root.life.confirmation', {
                url: '/confirmation',
                views: {
                    'step': {
                        templateUrl: Config.PAGES_DIR + 'Life/confirmation.html',
                        controller: 'LifeConfirmationCtrl',
                    }
                }
            })
            .state('root.life.summary', {
                url: '/summary',
                views: {
                    'step': {
                        templateUrl: Config.PAGES_DIR + 'Life/summary.html',
                        controller: 'LifeSummaryCtrl',
                    }
                }
            })
            .state('root.life.instruction', {
                url: '/instruction',
                views: {
                    'step': {
                        templateUrl: Config.PAGES_DIR + 'Life/instruction.html',
                        controller: 'LifeInstructionCtrl',
                    }
                }
            })
            .state('root.life.pzu', {
                url: '/pzu',
                views: {
                    'step': {
                        templateUrl: Config.PAGES_DIR + 'Life/pzu.html',
                        controller: 'LifePzuCtrl',
                    }
                }
            })
            .state('root.life.knowledge', {
                url: '/knowledge',
                views: {
                    'step': {
                        templateUrl: Config.PAGES_DIR + 'Life/knowledge.html',
                        controller: 'LifeKnowledgeCtrl',
                    }
                }
            })
            .state('root.life.incident', {
                url: '/incident',
                views: {
                    'step': {
                        templateUrl: Config.PAGES_DIR + 'Life/incident.html',
                        controller: 'LifeIncidentCtrl',
                    }
                }
            })
            .state('root.life.document', {
                url: '/document',
                views: {
                    'step': {
                        templateUrl: Config.PAGES_DIR + 'Life/document.html',
                        controller: 'LifeDocumentCtrl',
                    }
                }
            });
    } else if (Configurator.isLifeInsuranceWithPaymentsEnabled) {
        $stateProvider
            .state('root.life', {
                url: '/life',
                views: {
                    'page': {
                        templateUrl: Config.PAGES_DIR + 'life.html',
                        controller: 'LifeCtrl',
                    }
                },
                params: {
                    person: null,
                    persons: null,
                    choose: null,
                    prices: null,
                    partner: null,
                    assured: null,
                    summary: null,
                    isAssured: null,
                    isPartner: null,
                    saveResponse: null,
                    declarationEntity: null,
                    declarations: null,
                    hasEnteredDeclaration: null,
                    hasActiveDeclaration: null,
                }
            })
            .state('root.life.start', {
                url: '/start',
                views: {
                    'step': {
                        templateUrl: Config.PAGES_DIR + 'LifeWithPayments/' + Configurator.lifeInsuranceWithPayments.insurer + '/start.html',
                        controller: 'LifeWithPaymentsStartCtrl',
                    }
                }
            })
            .state('root.life.variant', {
                url: '/variant/:invitationToken',
                views: {
                    'step': {
                        templateUrl: Config.PAGES_DIR + 'LifeWithPayments/variant.html',
                        controller: 'LifeWithPaymentsVariantCtrl',
                    }
                },
                params: {
                    isChange: false
                }
            })
            .state('root.life.instruction', {
                url: '/instruction',
                views: {
                    'step': {
                        templateUrl: Config.PAGES_DIR + 'LifeWithPayments/' + Configurator.lifeInsuranceWithPayments.insurer + '/instruction.html',
                        controller: 'LifeWithPaymentsInstructionCtrl',
                    }
                }
            })
            .state('root.life.incident', {
                url: '/incident',
                views: {
                    'step': {
                        templateUrl: (Configurator.lifeInsuranceWithPayments.insurer === 'Unum' ?
                            Config.PAGES_DIR + 'LifeWithPayments/' + Configurator.lifeInsuranceWithPayments.insurer + '/instruction.html' :
                            Config.PAGES_DIR + 'Life/incident.html'),
                        controller: 'LifeWithPaymentsIncidentCtrl',
                    }
                }
            })
            .state('root.life.document', {
                url: '/document',
                views: {
                    'step': {
                        templateUrl: Config.PAGES_DIR + 'LifeWithPayments/' + Configurator.lifeInsuranceWithPayments.insurer + '/document.html',
                        controller: 'LifeWithPaymentsDocumentCtrl',
                    }
                }
            })
            .state('root.life.form', {
                url: '/form',
                views: {
                    'step': {
                        templateUrl: Config.PAGES_DIR + 'LifeWithPayments/form.html',
                        controller: 'LifeWithPaymentsFormCtrl',
                    }
                }
            })
            .state('root.life.confirmation', {
                url: '/confirmation',
                views: {
                    'step': {
                        templateUrl: Config.PAGES_DIR + 'LifeWithPayments/confirmation.html',
                        controller: 'LifeWithPaymentsConfirmationCtrl',
                    }
                }
            })
            .state('root.life.summary', {
                url: '/summary',
                views: {
                    'step': {
                        templateUrl: Config.PAGES_DIR + 'LifeWithPayments/' + Configurator.lifeInsuranceWithPayments.insurer + '/summary.html',
                        controller: 'LifeWithPaymentsSummaryCtrl',
                    }
                }
            })
            .state('root.life.list', {
                url: '/list',
                views: {
                    'step': {
                        templateUrl: Config.PAGES_DIR + 'LifeWithPayments/list.html',
                        controller: 'LifeWithPaymentsListCtrl'
                    }
                }
            })
            .state('root.life.details', {
                url: '/details',
                views: {
                    'step': {
                        templateUrl: Config.PAGES_DIR + 'LifeWithPayments/details.html',
                        controller: 'LifeWithPaymentsDetailsCtrl'
                    }
                },
                params: {
                    declarationUuid: null
                }
            })
            .state('root.life.change', {
                url: '/change',
                views: {
                    'step': {
                        templateUrl: Config.PAGES_DIR + 'LifeWithPayments/change.html',
                        controller: 'LifeWithPaymentsChangeCtrl'
                    }
                },
                params: {
                    declaration: null
                }
            });
        // if (Configurator.lifeInsuranceWithPayments.insurer === 'Pzu') {
        //     $stateProvider.state('root.life.knowledge', {
        //         url: '/knowledge',
        //         views: {
        //             'step': {
        //                 templateUrl: Config.PAGES_DIR + 'Life/knowledge.html',
        //                 controller: 'LifeKnowledgeCtrl',
        //             }
        //         }
        //     });
        // }
    }

    $stateProvider
        .state('root.nnw', {
            url: '/nnw',
            views: {
                'page': {
                    templateUrl: Config.PAGES_DIR + 'nnw.html',
                    // controller: 'LifeCtrl',
                }
            },
            params: {
                person: null,
                persons: null,
                choose: null,
                prices: null,
                partner: null,
                assured: null,
                summary: null,
                isAssured: null,
                isPartner: null,
                saveResponse: null,
            }
        })
        .state('root.nnw.start', {
            url: '/start',
            views: {
                'step': {
                    templateUrl: Config.PAGES_DIR + 'Nnw/start.html',
                    controller: 'NnwStartCtrl',
                }
            }
        })
        .state('root.house', {
            url: '/house',
            views: {
                'page': {
                    templateUrl: Config.PAGES_DIR + 'house.html',
                    // controller: 'LifeCtrl',
                }
            },
            params: {
                person: null,
                persons: null,
                choose: null,
                prices: null,
                partner: null,
                assured: null,
                summary: null,
                isAssured: null,
                isPartner: null,
                saveResponse: null,
            }
        })
        .state('root.house.start', {
            url: '/start',
            views: {
                'step': {
                    templateUrl: Config.PAGES_DIR + 'House/start.html',
                    controller: 'HouseStartCtrl',
                }
            }
        })
        .state('root.continue', {
            url: '/continue',
            views: {
                'page': {
                    templateUrl: Config.PAGES_DIR + 'continue.html',
                    // controller: 'LifeCtrl',
                }
            },
        })
        .state('root.continue.start', {
            url: '/start',
            views: {
                'step': {
                    templateUrl: Config.PAGES_DIR + 'Continue/start.html',
                    controller: 'ContinueStartCtrl',
                }
            }
        })
        .state('root.tourism', {
            url: '/tourism',
            views: {
                'page': {
                    templateUrl: Config.PAGES_DIR + 'tourism.html',
                    // controller: 'LifeCtrl',
                }
            },
            params: {
                person: null,
                persons: null,
                choose: null,
                prices: null,
                partner: null,
                assured: null,
                summary: null,
                isAssured: null,
                isPartner: null,
                saveResponse: null,
            }
        })
        .state('root.tourism.start', {
            url: '/start',
            views: {
                'step': {
                    templateUrl: Config.PAGES_DIR + 'Tourism/start.html',
                    controller: 'TourismStartCtrl',
                }
            }
        })
        .state('root.facilities', {
            url: '/facilities',
            views: {
                'page': {
                    templateUrl: Config.PAGES_DIR + 'facilities.html',
                    controller: 'FacilitiesCtrl',
                }
            }
        })
        .state('root.contact', {
            url: '/contact',
            views: {
                'page': {
                    templateUrl: Config.PAGES_DIR + 'contact.html',
                    controller: 'ContactCtrl',
                }
            }
        })
        .state('root.download', {
            url: '/download',
            views: {
                'page': {
                    templateUrl: Config.PAGES_DIR + 'download.html',
                    controller: 'DownloadCtrl',
                }
            }
        })
        .state('root.regulations', {
            url: '/regulations',
            views: {
                'page': {
                    templateUrl: Config.PAGES_DIR + 'regulations.html',
                    controller: 'RegulationsCtrl',
                }
            },
            params: {
                email: null,
                regulation: null
            }
        })
        .state('root.privacypolicy', {
            url: '/privacypolicy',
            views: {
                'page': {
                    templateUrl: Config.PAGES_DIR + 'privacypolicy.html',
                    controller: 'PrivacypolicyCtrl',
                }
            },
            params: {
                email: null,
                regulation: null
            }
        })
        .state('root.home', {
            url: '',
            abstract: true,
            views: {
                'page': {
                    templateUrl: Config.PAGES_DIR + 'home.html',
                    controller: 'HomeCtrl',
                }
            },
            params: {
                user: null,
                child: null,
                type: null,
                facility: null,
                obj: null,
                information: null,
                term: null,
                list: null,
                categories: null,
                details: null,
                filter: null,
                specializationObject: null,
                typeProteges: null,
                package: null,
                proposedDate: null
            }
        })
        .state('root.home.insurance', {
            url: '/insurance',
            views: {
                'content': {
                    templateUrl: Config.PAGES_HOME_DIR + 'insurance.html',
                    controller: 'InsuranceCtrl',
                }
            },
            params: {
                branch: null,
                package: null,
                statement: null
            }
        })
        .state('root.home.insurance.package', {
            url: '/package',
            views: {
                'step': {
                    templateUrl: Config.PAGES_HOME_DIR + 'Insurance/package.html',
                    controller: 'PackageCtrl',
                }
            }
        })
        .state('root.home.insurance.statement', {
            url: '/statement',
            views: {
                'step': {
                    templateUrl: Config.PAGES_HOME_DIR + 'Insurance/statement.html',
                    controller: 'StatementCtrl',
                }
            }
        })
        .state('root.home.insurance.form', {
            url: '/form',
            views: {
                'step': {
                    templateUrl: Config.PAGES_HOME_DIR + 'Insurance/form.html',
                    controller: 'FormCtrl',
                }
            }
        })
        .state('root.home.insurance.list', {
            url: '/list',
            views: {
                'step': {
                    templateUrl: Config.PAGES_HOME_DIR + 'Insurance/list.html',
                    controller: 'InsuranceListCtrl',
                }
            }
        })
        .state('root.home.insurance.details', {
            url: '/details',
            views: {
                'step': {
                    templateUrl: Config.PAGES_HOME_DIR + 'Insurance/details.html',
                    controller: 'InsuranceDetailsCtrl',
                }
            }
        })
        // @TODO <HEALTH2019>
        .state('root.home.healthInsurance', {
            url: '/healthInsurance',
            views: {
                'content': {
                    templateUrl: Config.PAGES_HOME_DIR + 'healthInsurance.html',
                    controller: 'HealthInsuranceCtrl',
                }
            },
            params: {
                branch: null,
                package: null,
                statement: null
            }
        })
        .state('root.home.healthInsurance.package', {
            url: '/package',
            views: {
                'step': {
                    templateUrl: Config.PAGES_HOME_DIR + 'HealthInsurance/package.html',
                    controller: 'HealthInsurancePackageCtrl',
                }
            }
        })
        .state('root.home.healthInsurance.statement', {
            url: '/statement',
            views: {
                'step': {
                    templateUrl: Config.PAGES_HOME_DIR + 'HealthInsurance/statement.html',
                    controller: 'HealthInsuranceStatementCtrl',
                }
            }
        })
        .state('root.home.healthInsurance.form', {
            url: '/form',
            views: {
                'step': {
                    templateUrl: Config.PAGES_HOME_DIR + 'HealthInsurance/form.html',
                    controller: 'HealthInsuranceFormCtrl',
                }
            }
        })
        .state('root.home.healthInsurance.list', {
            url: '/list',
            views: {
                'step': {
                    templateUrl: Config.PAGES_HOME_DIR + 'HealthInsurance/list.html',
                    controller: 'HealthInsuranceListCtrl',
                }
            }
        })
        .state('root.home.healthInsurance.details', {
            url: '/details',
            views: {
                'step': {
                    templateUrl: Config.PAGES_HOME_DIR + 'HealthInsurance/details.html',
                    controller: 'HealthInsuranceDetailsCtrl',
                }
            }
        })
        .state('root.home.healthInsurance.refundForm', {
            url: '/refund-form',
            views: {
                'step': {
                    templateUrl: Config.PAGES_DIR + 'Home/HealthInsurance/refund-form.html',
                    controller: 'HealthInsuranceRefundFormCtrl',
                    controllerAs: 'form'
                }
            }
        })
        // @TODO </HEALTH2019>
        .state('root.home.healthInsuranceWithPayments', {
            url: '/healthInsuranceWithPayments',
            views: {
                'content': {
                    templateUrl: Config.PAGES_HOME_DIR + 'healthInsuranceWithPayments.html',
                    controller: 'HealthInsuranceWithPaymentsCtrl',
                }
            },
            params: {
                branch: null,
                package: null,
                statement: null
            }
        })
        .state('root.home.healthInsuranceWithPayments.package', {
            url: '/package',
            views: {
                'step': {
                    templateUrl: Config.PAGES_HOME_DIR + 'HealthInsuranceWithPayments/package.html',
                    controller: 'HealthInsuranceWithPaymentsPackageCtrl',
                }
            }
        })
        .state('root.home.healthInsuranceWithPayments.form', {
            url: '/form',
            views: {
                'step': {
                    templateUrl: Config.PAGES_HOME_DIR + 'HealthInsuranceWithPayments/form.html',
                    controller: 'HealthInsuranceWithPaymentsFormCtrl',
                }
            },
            params: {
                package: null,
                proposedDate: null,
                lastDeclaration: null,
            }
        })
        .state('root.home.healthInsuranceWithPayments.summary', {
            url: '/summary',
            views: {
                'step': {
                    templateUrl: Config.PAGES_HOME_DIR + 'HealthInsuranceWithPayments/summary.html',
                    controller: 'HealthInsuranceWithPaymentsSummaryCtrl',
                }
            },
            params: {
                declaration: null
            }
        })
        .state('root.home.healthInsuranceWithPayments.list', {
            url: '/list',
            views: {
                'step': {
                    templateUrl: Config.PAGES_HOME_DIR + 'HealthInsuranceWithPayments/list.html',
                    controller: 'HealthInsuranceWithPaymentsListCtrl',
                }
            }
        })
        .state('root.home.healthInsuranceWithPayments.details', {
            url: '/details',
            views: {
                'step': {
                    templateUrl: Config.PAGES_HOME_DIR + 'HealthInsuranceWithPayments/details.html',
                    controller: 'HealthInsuranceWithPaymentsDetailsCtrl',
                }
            }
        })
        .state('root.home.mypackage', {
            url: '/mypackage',
            views: {
                'content': {
                    templateUrl: Config.PAGES_HOME_DIR + 'mypackage.html',
                    controller: 'MyPackageCtrl',
                }
            },
        })
        .state('root.home.profile', {
            url: '/profile',
            views: {
                'content': {
                    templateUrl: Config.PAGES_HOME_DIR + 'profile.html',
                    controller: 'ProfileCtrl',
                }
            },
        })
        .state('root.home.consent', {
            url: '/consent',
            views: {
                'content': {
                    templateUrl: Config.PAGES_HOME_DIR + 'consent.html',
                    controller: 'ConsentCtrl',
                }
            },
        })
        .state('root.home.change_password', {
            url: '/change_password',
            views: {
                'content': {
                    templateUrl: Config.PAGES_HOME_DIR + 'change_password.html',
                    controller: 'ChangePasswordCtrl',
                }
            },
        })
        .state('root.home.profile_proteges', {
            url: '/profile_proteges',
            views: {
                'content': {
                    templateUrl: Config.PAGES_HOME_DIR + 'profile_proteges.html',
                    controller: 'ProfileProtegesCtrl',
                }
            },
        })
        .state('root.home.profile_proteges.lists', {
            url: '/lists',
            views: {
                'step': {
                    templateUrl: Config.PAGES_HOME_DIR + 'ProfileProteges/lists.html',
                    controller: 'ProfileProtegesListsCtrl',
                }
            }
        })
        .state('root.home.profile_proteges.details', {
            url: '/details',
            views: {
                'step': {
                    templateUrl: Config.PAGES_HOME_DIR + 'ProfileProteges/details.html',
                    controller: 'ProfileProtegesDetailsCtrl',
                }
            },
            params: {
                details: null
            }
        })
        .state('root.home.profile_proteges.add', {
            url: '/add',
            views: {
                'step': {
                    templateUrl: Config.PAGES_HOME_DIR + 'ProfileProteges/add.html',
                    controller: 'ProfileProtegesAddCtrl',
                }
            },
        })
        .state('root.home.privacypolicy', {
            url: '/privacypolicy',
            views: {
                'content': {
                    templateUrl: Config.PAGES_HOME_DIR + 'privacypolicy.html',
                    controller: '',
                }
            },
        })
        .state('root.home.zoch', {
            url: '/zoch',
            abstract: true,
            views: {
                'content': {
                    templateUrl: Config.PAGES_HOME_DIR + 'zoch.html'
                }
            },
        })
        .state('root.home.zoch.insurance', {
            url: '/insurance',
            views: {
                'in': {
                    templateUrl: Config.PAGES_HOME_DIR + 'Zoch/insurance.html',
                    // controller: 'ZochInsuranceCtrl',
                }
            }
        })
        .state('root.home.zoch.insurance.list', {
            url: '/list',
            views: {
                'step': {
                    templateUrl: Config.PAGES_HOME_DIR + 'Zoch/Insurance/list.html',
                    controller: 'ZochInsuranceListCtrl',
                }
            },
            params: {
                user: null
            }
        })
        .state('root.home.zoch.insurance.details', {
            url: '/details',
            views: {
                'step': {
                    templateUrl: Config.PAGES_HOME_DIR + 'Zoch/Insurance/details.html',
                    controller: 'ZochInsuranceDetailsCtrl',
                }
            },
            params: {
                insurance: null
            }
        })
        .state('root.home.zoch.insurance.occurrence', {
            url: '/occurrence',
            views: {
                'step': {
                    templateUrl: Config.PAGES_HOME_DIR + 'Zoch/Insurance/occurrence.html',
                    controller: 'ZochInsuranceOccurrenceCtrl',
                }
            },
            params: {
                declaration: null
            }
        })
        .state('root.home.zoch.insurance.notification', {
            url: '/notification',
            views: {
                'step': {
                    templateUrl: Config.PAGES_HOME_DIR + 'Zoch/Insurance/notification.html',
                    controller: 'ZochInsuranceNotificationCtrl',
                }
            },
            params: {
                declaration: null
            }
        })
        .state('root.home.zoch.insurance.add', {
            url: '/add',
            views: {
                'step': {
                    templateUrl: Config.PAGES_HOME_DIR + 'Zoch/Insurance/add.html',
                    controller: 'ZochInsuranceAddCtrl',
                }
            },
            params: {
                user: null
            }
        })
        // @TODO <HEALTH2019>
        .state('root.home.zoch.healthInsurance', {
            url: '/healthInsurance',
            views: {
                'in': {
                    templateUrl: Config.PAGES_HOME_DIR + 'Zoch/healthInsurance.html',
                    // controller: 'ZochInsuranceCtrl',
                }
            }
        })
        .state('root.home.zoch.healthInsurance.list', {
            url: '/list',
            views: {
                'step': {
                    templateUrl: Config.PAGES_HOME_DIR + 'Zoch/HealthInsurance/list.html',
                    controller: 'ZochHealthInsuranceListCtrl',
                }
            },
            params: {
                user: null
            }
        })
        .state('root.home.zoch.healthInsurance.details', {
            url: '/details',
            views: {
                'step': {
                    templateUrl: Config.PAGES_HOME_DIR + 'Zoch/HealthInsurance/details.html',
                    controller: 'ZochHealthInsuranceDetailsCtrl',
                }
            },
            params: {
                insurance: null
            }
        })
        .state('root.home.zoch.healthInsurance.occurrence', {
            url: '/occurrence',
            views: {
                'step': {
                    templateUrl: Config.PAGES_HOME_DIR + 'Zoch/HealthInsurance/occurrence.html',
                    controller: 'ZochHealthInsuranceOccurrenceCtrl',
                }
            },
            params: {
                declaration: null
            }
        })
        .state('root.home.zoch.healthInsurance.notification', {
            url: '/notification',
            views: {
                'step': {
                    templateUrl: Config.PAGES_HOME_DIR + 'Zoch/HealthInsurance/notification.html',
                    controller: 'ZochHealthInsuranceNotificationCtrl',
                }
            },
            params: {
                declaration: null
            }
        })
        .state('root.home.zoch.healthInsurance.add', {
            url: '/add',
            views: {
                'step': {
                    templateUrl: Config.PAGES_HOME_DIR + 'Zoch/HealthInsurance/add.html',
                    controller: 'ZochHealthInsuranceAddCtrl',
                }
            },
            params: {
                user: null
            }
        })
        // @TODO </HEALTH2019>
        // TUW PZUW
        .state('root.home.zoch.healthPzuw', {
            url: '/healthPzuw',
            views: {
                'in': {
                    templateUrl: Config.PAGES_HOME_DIR + 'Zoch/healthInsurance.html',
                }
            }
        })
        .state('root.home.zoch.healthPzuw.add', {
            url: '/add',
            views: {
                'step': {
                    templateUrl: Config.PAGES_HOME_DIR + 'Zoch/HealthPzuw/add.html',
                    controller: 'ZochHealthPzuwAddCtrl',
                }
            },
            params: {
                user: null
            }
        })
        .state('root.home.zoch.healthPzuw.list', {
            url: '/list',
            views: {
                'step': {
                    templateUrl: Config.PAGES_HOME_DIR + 'Zoch/HealthPzuw/list.html',
                    controller: 'ZochHealthPzuwListCtrl',
                }
            },
            params: {
                user: null
            }
        })
        .state('root.home.zoch.healthPzuw.details', {
            url: '/details',
            views: {
                'step': {
                    templateUrl: Config.PAGES_HOME_DIR + 'Zoch/HealthPzuw/details.html',
                    controller: 'ZochHealthPzuwDetailsCtrl',
                }
            },
            params: {
                user: null
            }
        })
        .state('root.home.zoch.healthPzuw.withdrawal', {
            url: '/withdrawal',
            views: {
                'step': {
                    templateUrl: Config.PAGES_HOME_DIR + 'Zoch/HealthPzuw/withdrawal.html',
                    controller: 'ZochHealthPzuwWithdrawalCtrl',
                }
            },
            params: {
                declaration: null
            }
        })
        .state('root.home.zoch.healthPzuw.notification', {
            url: '/notification',
            views: {
                'step': {
                    templateUrl: Config.PAGES_HOME_DIR + 'Zoch/HealthPzuw/notification.html',
                    controller: 'ZochHealthPzuwNotificationCtrl',
                }
            },
            params: {
                declaration: null
            }
        })
        // LIFE INSURANCE
        .state('root.home.zoch.lifeInsurance', {
            url: '/life-insurance',
            views: {
                'in': {
                    templateUrl: Config.PAGES_HOME_DIR + 'Zoch/life_insurance.html',
                }
            }
        })
        .state('root.home.zoch.lifeInsurance.list', {
            url: '/list',
            views: {
                'step': {
                    templateUrl: Config.PAGES_HOME_DIR + 'Zoch/LifeInsurance/list.html',
                    controller: 'ZochLifeInsuranceListCtrl',
                }
            },
            params: {
                user: null
            }
        })
        .state('root.home.zoch.lifeInsurance.details', {
            url: '/details',
            views: {
                'step': {
                    templateUrl: Config.PAGES_HOME_DIR + 'Zoch/LifeInsurance/details.html',
                    controller: 'ZochLifeInsuranceDetailsCtrl',
                }
            },
            params: {
                insurance: null
            }
        })
        .state('root.home.zoch.lifeInsurance.related', {
            url: '/related',
            views: {
                'step': {
                    templateUrl: Config.PAGES_HOME_DIR + 'Zoch/LifeInsurance/related.html',
                    controller: 'ZochLifeInsuranceRelatedCtrl',
                }
            },
            params: {
                insurance: null
            }
        })
        .state('root.home.zoch.lifeInsurance.occurrence', {
            url: '/occurrence',
            views: {
                'step': {
                    templateUrl: Config.PAGES_HOME_DIR + 'Zoch/LifeInsurance/occurrence.html',
                    controller: 'ZochLifeInsuranceOccurrenceCtrl',
                }
            },
            params: {
                declaration: null
            }
        })
        .state('root.home.zoch.lifeInsurance.notification', {
            url: '/notification',
            views: {
                'step': {
                    templateUrl: Config.PAGES_HOME_DIR + 'Zoch/LifeInsurance/notification.html',
                    controller: 'ZochLifeInsuranceNotificationCtrl',
                }
            },
            params: {
                declaration: null
            }
        })
        .state('root.home.zoch.lifeInsurance.add', {
            url: '/add',
            views: {
                'step': {
                    templateUrl: Config.PAGES_HOME_DIR + 'Zoch/LifeInsurance/add.html',
                    controller: 'ZochLifeInsuranceAddCtrl',
                }
            },
            params: {
                user: null,
                person: null,
                persons: null,
                choose: null,
                prices: null,
                partner: null,
                assured: null,
                summary: null,
                isAssured: null,
                isPartner: null,
                saveResponse: null,
            }
        })
        // .state('root.home.zoch.lifeInsurance.add.variant', {
        //     url: '/variant',
        //     views: {
        //         'subStep': {
        //             templateUrl: Config.PAGES_HOME_DIR + 'Zoch/LifeInsurance/Add/variant.html',
        //             controller: 'ZochLifeInsuranceAddVariantCtrl',
        //         }
        //     }
        // })
        // .state('root.home.zoch.lifeInsurance.add.salaried', {
        //     url: '/salaried',
        //     views: {
        //         'subStep': {
        //             templateUrl: Config.PAGES_HOME_DIR + 'Zoch/LifeInsurance/Add/salaried.html',
        //             controller: 'ZochLifeInsuranceAddSalariedCtrl',
        //         }
        //     }
        // })
        // .state('root.home.zoch.lifeInsurance.add.data', {
        //     url: '/data',
        //     views: {
        //         'subStep': {
        //             templateUrl: Config.PAGES_HOME_DIR + 'Zoch/LifeInsurance/Add/data.html',
        //             controller: 'ZochLifeInsuranceAddDataCtrl',
        //         }
        //     }
        // })
        // .state('root.home.zoch.lifeInsurance.add.confirmation', {
        //     url: '/confirmation',
        //     views: {
        //         'subStep': {
        //             templateUrl: Config.PAGES_HOME_DIR + 'Zoch/LifeInsurance/Add/confirmation.html',
        //             controller: 'ZochLifeInsuranceAddConfirmationCtrl',
        //         }
        //     }
        // })
        // .state('root.home.zoch.lifeInsurance.add.summary', {
        //     url: '/summary',
        //     views: {
        //         'subStep': {
        //             templateUrl: Config.PAGES_HOME_DIR + 'Zoch/LifeInsurance/Add/summary.html',
        //             controller: 'ZochLifeInsuranceAddSummaryCtrl',
        //         }
        //     }
        // })

        .state('root.home.zoch.manage', {
            url: '/manage',
            views: {
                'in': {
                    templateUrl: Config.PAGES_HOME_DIR + 'Zoch/manage.html',
                    controller: 'ZochManageCtrl',
                }
            }
        })
        .state('root.home.zoch.workers', {
            url: '/workers',
            views: {
                'in': {
                    templateUrl: Config.PAGES_HOME_DIR + 'Zoch/workers.html',
                    // controller: 'ZochWorkersCtrl',
                }
            }
        })
        .state('root.home.zoch.workers.list', {
            url: '/list',
            views: {
                'step': {
                    templateUrl: Config.PAGES_HOME_DIR + 'Zoch/Workers/list.html',
                    controller: 'ZochWorkersListCtrl',
                }
            }
        })
        .state('root.home.zoch.workers.details', {
            url: '/details',
            views: {
                'step': {
                    templateUrl: Config.PAGES_HOME_DIR + 'Zoch/Workers/details.html',
                    controller: 'ZochWorkersDetailsCtrl',
                }
            },
            params: {
                worker: null
            }
        })
        .state('root.home.zoch.workers.add', {
            url: '/add',
            views: {
                'step': {
                    templateUrl: Config.PAGES_HOME_DIR + 'Zoch/Workers/add.html',
                    controller: 'ZochWorkersAddCtrl',
                }
            }
        })
        .state('root.home.zoch.report', {
            url: '/report',
            views: {
                'in': {
                    templateUrl: Config.PAGES_HOME_DIR + 'Zoch/report.html',
                    // controller: 'ZochInsuranceCtrl',
                }
            }
        })
        .state('root.home.zoch.report.list', {
            url: '/list',
            views: {
                'step': {
                    templateUrl: Config.PAGES_HOME_DIR + 'Zoch/Report/list.html',
                    controller: 'ZochReportListCtrl',
                }
            },
            params: {
                user: null
            }
        })
        .state('root.home.zoch.report.healthlist', {
            url: '/healthlist',
            views: {
                'step': {
                    templateUrl: Config.PAGES_HOME_DIR + 'Zoch/Report/healthlist.html',
                    controller: 'ZochReportHealthListCtrl',
                }
            },
            params: {
                user: null
            }
        })
        .state('root.home.zoch.report.healthPzuwList', {
            url: '/health-pzuw-list',
            views: {
                'step': {
                    templateUrl: Config.PAGES_HOME_DIR + 'Zoch/Report/health-pzuw-list.html',
                    controller: 'ZochReportHealthPzuwListCtrl',
                }
            },
            params: {
                user: null
            }
        })
        .state('root.home.zoch.report.lifelist', {
            url: '/lifelist',
            views: {
                'step': {
                    templateUrl: Config.PAGES_HOME_DIR + 'Zoch/Report/lifelist.html',
                    controller: 'ZochReportLifeListCtrl',
                    controllerAs: '$ctrl'
                }
            },
            params: {
                user: null
            }
        })

        .state('root.home.zoch.file', {
            url: '/file',
            views: {
                'in': {
                    templateUrl: Config.PAGES_HOME_DIR + 'Zoch/file.html',
                    // controller: 'ZochInsuranceCtrl',
                }
            }
        })
        .state('root.home.zoch.file.list', {
            url: '/list',
            views: {
                'step': {
                    templateUrl: Config.PAGES_HOME_DIR + 'Zoch/File/list.html',
                    controller: 'ZochFileListCtrl',
                }
            },
            params: {
                user: null
            }
        })
        .state('root.home.zoch.bill', {
            url: '/bill',
            views: {
                'in': {
                    templateUrl: Config.PAGES_HOME_DIR + 'Zoch/bill.html',
                    // controller: 'ZochInsuranceCtrl',
                }
            }
        })
        .state('root.home.zoch.bill.list', {
            url: '/list',
            views: {
                'step': {
                    templateUrl: Config.PAGES_HOME_DIR + 'Zoch/Bill/list.html',
                    controller: 'ZochBillListCtrl',
                }
            },
            params: {
                user: null
            }
        })
        // @TODO: <HEALTH2019>
        .state('root.home.zoch.upload', {
            url: '/upload',
            views: {
                'in': {
                    templateUrl: Config.PAGES_HOME_DIR + 'Zoch/Upload/upload.html',
                    controller: 'ZochUploadCtrl',
                    controllerAs: 'file'
                }
            }
        })
        .state('root.insurer', {
            url: '/insurer',
            views: {
                'page': {
                    templateUrl: Config.PAGES_DIR + 'insurer.html',
                }
            },
        })
        .state('root.insurer.tuwPzuw', {
            url: '/tuw-pzuw',
            views: {
                'step': {
                    templateUrl: Config.PAGES_DIR + 'Insurer/tuz-pzuw.html',
                    controller: 'InsurerTuzPzuwCtrl',
                }
            }
        });
    // @TODO: </HEALTH2019>
}]);
